export const authTypes = {
    login: "[Auth] login",
    logout: "[Auth] logout",
    token: "[Auth] token",
};
